import { gql } from "../../__generated__/gql";

export const RefreshSubscriptionUser = gql(/* Graphql */ `
    query RefreshSubscriptionUser($where: UserWhereUniqueInput!) {
        user(where: $where) {
            id
            subscriptionType
            subscriptionInterval
        }
    }
`);

export const GetRecentActivityItems = gql(/* Graphql */ `
    query GetRecentActivityItems($take: Float, $cursor: DateTime) {
        getRecentActivityItems(take: $take, cursor: $cursor) {
            items {
                id
                title
                updatedAt
                type
                url
            }
            hasMore
            nextCursor
        }
    }
`);
